'use strict';

(function () {
  'use strict';

  angular.module('msPublicActivities', ['ngAnimate', 'msUtility', 'msCore', 'msActivityServices', 'msActivities', 'msTracker', 'msGoals', 'translations', 'angularModalService', 'ui.router.default', 'ngStorage', 'ngMessages', 'infinite-scroll']).constant('context', 'public').run(['$rootScope', '$timeout', '$document', '$state', '$log', 'msAuth', 'windowSvc', 'pageTitleSvc', 'eventTrackingSvc', 'NotifyingSvc', 'ModalService', function ($rootScope, $timeout, $document, $state, $log, msAuth, windowSvc, pageTitleSvc, eventTrackingSvc, NotifyingSvc, ModalService) {
    eventTrackingSvc.init();
    // send pageviews to google analytics
    eventTrackingSvc.registerEventListeners();
    // check to see if they're trying to access an authed page without being logged in
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
      if (msAuth.isLoggedIn() && !msAuth.isWriteOnlyUser()) {
        // user is not logged in and the route requires auth, send them to login
        var _redirect = $state.href(toState.name, toParams).replace('act/', 'v/activity/');
        $log.debug('publicActivites stateChangeStart: User is logged in - redirecting to ' + _redirect);
        windowSvc.windowNavigate(_redirect);
        event.preventDefault();
      }
    });
    //scroll to the top of a new page
    $rootScope.$on('$stateChangeSuccess', function () {
      $document[0].body.scrollTop = $document[0].documentElement.scrollTop = 0;
    });
    $rootScope.$state = $state;
    pageTitleSvc.registerEventListeners();
    NotifyingSvc.subscribe(NotifyingSvc.EVENTS.OPEN_MODAL, function (event, data) {
      ModalService.showModal({
        appendElement: angular.element($document[0].getElementById('modalTarget')),
        templateUrl: data.templateUrl || 'vnext/templates/generic-modal.html',
        controller: data.controller || 'GenericModalCtrl',
        controllerAs: data.controllerAs || '$ctrl',
        inputs: data.inputs
      }).then(function (modal) {
        modal.close.then(function (result) {
          if (angular.isFunction(data.closeCallback)) {
            data.closeCallback(result);
          }
        });
      });
    });
  }]);
})();